export const ActionTypes = {
  SET_STORE_INCOME: 'SET_STORE_INCOME',
};
